import styled, { spacing } from "@rentiohq/web-theme";

// RentMatch wordmark brand hue — a brand asset, intentionally not a theme
// token (mirrors RM_COLORS.brand in the RentMatch scene).
export const RENTMATCH_BRAND_COLOR = "#FF3A59";

export const RentMatchPill = styled.button.attrs({ type: "button" })`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  border-radius: 100px;
  padding: 4px ${spacing("tight")};
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  color: ${({ theme }) => theme.getColor("white")};
  background-color: ${RENTMATCH_BRAND_COLOR};
`;

// No bedroom glyph exists in @rentiohq/web-assets, so render a small inline
// bed icon. Drawn as a thin outline (stroke, no fill) to match the streamline
// style of the other meta icons; inherits the surrounding text color.
export const BedIcon = styled.svg`
  width: 16px;
  height: 16px;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1px;
  stroke-linecap: round;
  stroke-linejoin: round;
`;
